import React from 'react'
import { useViewport } from '@chilecompra/react-kit'
import { Breadcrumb, Breadcrumbs, Typography } from '@chilecompra/react-kit/components'
import routes from '../../config/settings/routes'
import Jumbotron from '../../components/Basics/Jumbotron'
import {
  Card,
  GridContainer,
  GridItem,
  JumboDescription,
  JumboTitle,
  Root,
  StarIcon
} from './AgilePurchaseSection.styles'
import ProtectByFeatures from '../../components/Security/ProtectByFeatures'

/**
 * The AgilePurchaseSection's container.
 *
 */
const AgilePurchaseSection = () => {
  const {
    size: { isUpToMedium }
  } = useViewport()

  return (
    <Root>
      <GridContainer>
        <GridItem xs={12}>
          <Jumbotron color="blue" height={isUpToMedium ? '295px' : 'auto'}>
            <GridItem xs={12}>
              <Breadcrumbs>
                <Breadcrumb to={routes.root} variant="link">
                  Datos Abiertos
                </Breadcrumb>
                <Breadcrumb>Compra Ágil</Breadcrumb>
              </Breadcrumbs>
            </GridItem>
            <GridContainer spacing={0}>
              <GridItem xs={3}>
                <JumboTitle>Compra Ágil</JumboTitle>
              </GridItem>
              <ProtectByFeatures rule={features => features['cl.chilecompra.datos-abiertos/new-section']}>
                <GridItem xs={4}>
                  <Card color="primary" width="88px" display="flex">
                    <Typography
                      variant="body1"
                      color="primary"
                      fontWeight="normal"
                      fontSize="12px"
                      lineHeight="14px"
                      padding="4px 0 0 0"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      NUEVO <StarIcon style={{ verticalAlign: 'middle' }} />
                    </Typography>
                  </Card>
                </GridItem>
              </ProtectByFeatures>
            </GridContainer>

            <GridItem xs={12}>
              <JumboDescription>
                Conoce las cifras generales de compras realizadas mediante Compra Ágil, incluyendo el monto transado,
                órdenes de compra, y cotizaciones enviadas por año.
              </JumboDescription>
            </GridItem>
          </Jumbotron>
        </GridItem>
      </GridContainer>
    </Root>
  )
}
export default AgilePurchaseSection
